module.exports = __webpack_public_path__ + "static/media/003-house.991b5e57.svg";